import { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function Contact({ member, shopId, onSaved }) {
  const [form, setForm] = useState({
    member_handphone:           member?.member_handphone           || '',
    member_resident_landphone:  member?.member_resident_landphone  || '',
    member_email:               member?.member_email               || '',
    market_handphone:           member?.market_handphone           || '',
    market_landphone:           member?.market_landphone           || '',
    market_fax:                 member?.market_fax                 || '',
  });
  const [saving, setSaving] = useState(false);
  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      if (member?.id) {
        const { data } = await api.put(`/members/${member.id}`, form);
        onSaved(data);
      } else {
        const { data } = await api.post('/members', { shop_id: shopId, ...form });
        onSaved(data);
      }
      toast.success('Contact info saved');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Member contacts */}
      <div>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text2)', marginBottom: 14, textTransform: 'uppercase', letterSpacing: '.05em' }}>
          Member Contact
        </h4>
        <div className="grid-3">
          <div className="form-group">
            <label className="form-label">Hand Phone</label>
            <input className="form-input" type="tel" value={form.member_handphone} onChange={set('member_handphone')} placeholder="+94 7X XXX XXXX" />
          </div>
          <div className="form-group">
            <label className="form-label">Resident Land Phone</label>
            <input className="form-input" type="tel" value={form.member_resident_landphone} onChange={set('member_resident_landphone')} placeholder="0XX XXX XXXX" />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={form.member_email} onChange={set('member_email')} placeholder="email@example.com" />
          </div>
        </div>
      </div>

      {/* Market contacts */}
      <div>
        <h4 style={{ fontSize: 13, fontWeight: 600, color: 'var(--text2)', marginBottom: 14, textTransform: 'uppercase', letterSpacing: '.05em' }}>
          Market Contact
        </h4>
        <div className="grid-3">
          <div className="form-group">
            <label className="form-label">Market Hand Phone</label>
            <input className="form-input" type="tel" value={form.market_handphone} onChange={set('market_handphone')} placeholder="+94 7X XXX XXXX" />
          </div>
          <div className="form-group">
            <label className="form-label">Market Land Phone</label>
            <input className="form-input" type="tel" value={form.market_landphone} onChange={set('market_landphone')} placeholder="0XX XXX XXXX" />
          </div>
          <div className="form-group">
            <label className="form-label">Market email</label>
            <input className="form-input" type="email" value={form.market_fax} onChange={set('market_fax')} placeholder="email@example.com" />
          </div>
        </div>
      </div>

      <div className="section-save-bar">
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save Contact Info'}
        </button>
      </div>
    </div>
  );
}
